import React, { Fragment, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { Alert, Divider, Grid } from '@mui/material';
import { Form, Pill, ToggleSwitch } from 'Components';

import Slider from 'Components/Slider';
import CustomTime from "Modules/alerts/common/components/CustomTime";

// Helpers
import { isOverlapped } from '../../../../common/helpers/alertCommon'
import { LogManagerConsole } from 'Core/logManager';

// Data
import INITIAL_DAYS from 'Modules/alerts/common/days.json';
import moment from "moment";

const Step2 = (props) => {

    const { currentAlert, value, onChange, formRef, nextStep } = props
    const { schedule } = value
    const { messages } = useIntl()

    const [days, setDays] = useState([])
    const [applyMondays, setApplyMondays] = useState(false)

    useEffect(() => {
        if (days.length == 0) {
            const initialDays = [...INITIAL_DAYS];
            let daysToShow = [];

            // Gets the days from the alert schedule given its key.
            const getConfiguredDay = (dayKey) => schedule?.customSchedule?.filter(({ day }) => day === mapDayKeyToLabel[dayKey]);

            initialDays.forEach((day) => {
                const { key: dayKey } = day;
                const configuredDays = getConfiguredDay(dayKey) || [];

                // Formats a day given from the API to add it the fields and show it correctly in the UI.
                const formatedDay = (dayVal) => {
                    const { day: dayLabel } = dayVal;

                    return {
                        ...dayVal,
                        timeFrom: moment(moment().format('YYYY-MM-DD') + "T" + dayVal.timeFrom).toDate(),
                        timeTo: moment(moment().format('YYYY-MM-DD') + "T" + dayVal.timeTo).toDate(),
                        ...mapDayLabelToDayKey[dayLabel]
                    };
                }

                if (configuredDays?.length === 0) {
                    daysToShow.push({ ...day, timeFrom: moment().set("hour", 8).set("minute", 0).toDate(), timeTo: moment().set("hour", 18).set("minute", 59).toDate() });
                } else {
                    const formatedDays = configuredDays?.map((day, index) => {
                        const isParentDay = index === 0;

                        return { ...formatedDay(day), parentDay: isParentDay };
                    });

                    daysToShow = [...daysToShow, ...formatedDays];
                }
            });

            setDays(daysToShow);
        }
    }, [])

    useEffect(() => {
        if (!schedule || !schedule?.frequency) {
            onChange({ ...value, schedule: { ...schedule, frequency: "Everyday", occurrences: currentAlert.code == "OffHour" ? "HourlySummary":  "EveryEvent", occurrencesLimitPerDay: 0, afterConsecutiveEvents: 0 } })
        }
    }, [schedule])


    const changeDay = (day, key, valueObj, index) => {
        let newDay = {};
        if (key === 'checked' && !valueObj) {
            newDay = {
                ...day,
                checked: valueObj,
                startedEnable: null,
                startedDisable: null,
            };
        } else {
            newDay = { ...day, [key]: valueObj };
        }
        const updatedDays = [...days.slice(0, index), newDay, ...days.slice(index + 1)];

        setDays(updatedDays);
        return updatedDays
    };


    const validateRange = (day, posc) => {
        const validateOverlapping = () => {

            let isOverlapping = false;
            let otherDays = [...days]
            otherDays.splice(posc, 1)
            otherDays = otherDays.filter(x => x.day === day.day)

            LogManagerConsole("WizardAlert", "validateOverlapping", otherDays, day, posc)

            otherDays.forEach(x => {
                if (day.timeFrom <= x.timeFrom && x.timeFrom <= day.timeTo) return isOverlapping = true; // b starts in a
                if (day.timeFrom <= x.timeTo && x.timeTo <= day.timeTo) return isOverlapping = true; // b ends in a
                if (x.timeFrom < day.timeFrom && day.timeTo < x.timeTo) return isOverlapping = true; // a in b
            })

            return isOverlapping;
        }

        const shouldValidateOverlapping = (day) => {
            const { checked, timeFrom, timeTo } = day;
            const completedRange = timeFrom && timeTo;

            return !!(checked && completedRange);
        };

        return shouldValidateOverlapping(day) ? !validateOverlapping() : true;
    };

    const validateDay = (day) => {
        const { checked, timeFrom, timeTo } = day;
        return checked ? timeFrom < timeTo : true;
    };

    const validateAllDay = (day, posc) => {
        let validateDayResult = validateDay(day)
        if (validateDayResult)
            validateDayResult = validateRange(day, posc)

        return validateDayResult
    }

    const mapDayKeyToLabel = {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
    };

    const mapDayLabelToDayKey = {
        Monday: { key: 'monday', checked: true, label: 'M' },
        Tuesday: { key: 'tuesday', checked: true, label: 'T' },
        Wednesday: { key: 'wednesday', checked: true, label: 'W' },
        Thursday: { key: 'thursday', checked: true, label: 'Th' },
        Friday: { key: 'friday', checked: true, label: 'F' },
        Saturday: { key: 'saturday', checked: true, label: 'S' },
        Sunday: { key: 'sunday', checked: true, label: 'Su' },
    };

    const addDayCallback = (newDay) => {
        const indexDay = days.indexOf(newDay) + 1;
        const daysCopy = [...days];
        const resetDay = (day) => (
            {
                ...day,
                timeFrom: moment().set("hour", 8).set("minute", 0).toDate(),
                timeTo: moment().set("hour", 18).set("minute", 59).toDate(),
                parentDay: false,
            });
        daysCopy.splice(indexDay, 0, resetDay(newDay));

        setDays(daysCopy);
        return daysCopy
    };

    const removeDayCallback = (dayToRemove) => {
        const indexDay = days.indexOf(dayToRemove);
        const daysCopy = [...days];
        daysCopy.splice(indexDay, 1);

        setDays(daysCopy);
        return daysCopy
    };

    // // Apply value from Monday to every day
    const applyModaysTime = (_days) => {
        let newDays = _days || days
        // Gets the monday configuration. 
        const mondaySetup = [...newDays.filter((dayObject) => dayObject.key === 'monday')];

        // Builds the new week according to the monday's configuration. 
        let newConfiguredDays = [];

        INITIAL_DAYS.forEach((day) => {
            mondaySetup.forEach((mondayDay) => {
                const {
                    timeFrom,
                    timeTo,
                    parentDay,
                    checked,
                } = mondayDay;

                const clonedDay = {
                    ...day,
                    timeFrom,
                    timeTo,
                    parentDay,
                    checked,
                }

                newConfiguredDays.push(clonedDay);
            });
        });

        setDays(newConfiguredDays);
    };

    /**
   * Validates if the current alert should display the show often component. 
   * If the alert shouldn't show it please add it to the excludedAlerts below.
   * @param {string} alertType - The current alert type.
   */
    const showOftenAlerts = (alertType) => {
        const excludedAlerts = ["OffHour"];

        return true //!excludedAlerts.find((excludedAlert) => excludedAlert === alertType);
    }

    LogManagerConsole("WizardAlert", "value", value)
    return (
        <Form ref={formRef}
            noSubmit
            onValidSubmit={() => {

                const get24HFormat = (time) => moment(time).format("HH:mm");

                let scheduleNew = schedule || {}
                let checkedDays = days.filter(x => x.checked)
                scheduleNew = {
                    id: schedule?.id,
                    ...schedule,
                    customSchedule: checkedDays.length > 0 && checkedDays.map(x => {
                        return {
                            ...x, timeFrom: get24HFormat(x.timeFrom), timeTo: get24HFormat(x.timeTo)
                        }
                    }) || []
                }
                onChange({ ...value, schedule: scheduleNew })
                nextStep()
            }}
            onSubmit={() => {

                let isValidDate = true;
                days.forEach((x, posc) => {
                    let validate = validateAllDay(x, posc)
                    if (!validate)
                        isValidDate = false
                })

                return isValidDate;
            }}
        >
            <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 20 }}>
                <Grid item >
                    <label className="input-normal-label">{messages['alertsNewAlert_whenShouldThisAlertTriggerLabel']}</label>
                    <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Everyday", name: messages["alertsNewAlert_everydayLabel"] }}
                                outlined={schedule?.frequency !== "Everyday"}
                                onClick={(entity) => {
                                    onChange({ ...value, schedule: { ...schedule, frequency: "Everyday" } })
                                    setDays(INITIAL_DAYS.map(x => { return { ...x, timeFrom: moment().set("hour", 8).set("minute", 0).toDate(), timeTo: moment().set("hour", 18).set("minute", 59).toDate() } }))
                                    setApplyMondays(false)
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Weekdays", name: messages["alertsNewAlert_weekdaysLabel"] }}
                                outlined={schedule?.frequency !== "Weekdays"}
                                onClick={(entity) => {
                                    onChange({ ...value, schedule: { ...schedule, frequency: "Weekdays" } })
                                    setDays(INITIAL_DAYS.map(x => { return { ...x, timeFrom: moment().set("hour", 8).set("minute", 0).toDate(), timeTo: moment().set("hour", 18).set("minute", 59).toDate() } }))
                                    setApplyMondays(false)
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Weekends", name: messages["alertsNewAlert_weekendsLabel"] }}
                                outlined={schedule?.frequency !== "Weekends"}
                                onClick={(entity) => {
                                    onChange({ ...value, schedule: { ...schedule, frequency: "Weekends" } })
                                    setDays(INITIAL_DAYS.map(x => { return { ...x, timeFrom: moment().set("hour", 8).set("minute", 0).toDate(), timeTo: moment().set("hour", 18).set("minute", 59).toDate() } }))
                                    setApplyMondays(false)
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Custom", name: messages["alertsNewAlert_customLabel"] }}
                                outlined={schedule?.frequency !== "Custom"}
                                onClick={(entity) => {
                                    onChange({ ...value, schedule: { ...schedule, frequency: "Custom" } })
                                    setDays(INITIAL_DAYS.map(x => { return { ...x, timeFrom: moment().set("hour", 8).set("minute", 0).toDate(), timeTo: moment().set("hour", 18).set("minute", 59).toDate() } }))
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {
                    schedule?.frequency == "Custom" &&
                    <Fragment>
                        <Grid item className={schedule?.frequency !== "Custom" ? "disabledArea" : ""} style={{ paddingTop: 10 }}>
                            <ToggleSwitch
                                id="applyAllsMonday"
                                small
                                blueToggle
                                optionLabels={["", ""]}
                                label={messages['alertsNewAlert_applyModaysTimesToAll']}
                                checked={applyMondays}
                                onChange={(event) => {
                                    setApplyMondays(event)
                                    if (event) applyModaysTime()
                                }}
                            />
                        </Grid>
                        <Grid item className={schedule?.frequency !== "Custom" ? "disabledArea" : ""}>
                            {
                                days.map((day, key) => {

                                    let validRange = validateRange(day, key);
                                    let validDate = validateDay(day);

                                    return (
                                        <CustomTime
                                            key={key}
                                            value={key}
                                            day={day}
                                            checkOneDay={(e) => changeDay(days[e], "checked", !days[e].checked, e)}
                                            handleTimeChange={(newValue, action) => {
                                                let newDays = changeDay(days[key], action, newValue, key)
                                                if (applyMondays) applyModaysTime(newDays)
                                            }}
                                            addDayCallback={() => {
                                                let newDays = addDayCallback(day)
                                                if (applyMondays) applyModaysTime(newDays)
                                            }}
                                            removeDayCallback={() => {
                                                let newDays = removeDayCallback(day)
                                                if (applyMondays) applyModaysTime(newDays)
                                            }}
                                            validRange={validRange}
                                            overlappingDatesErrorMessage={messages['alertsNewAlert_OverlappingDatesErrorMessage']}
                                            isValidDay={validDate}
                                            invalidDayMessage={messages['alertsNewAlert_HoursCompletationValidation']}
                                            disableAddChange={applyMondays && day.day !== "Monday"}
                                        />
                                    )
                                })
                            }
                        </Grid>
                    </Fragment>
                }
                <Grid item style={{ paddingTop: "30px" }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_aletTriggerOptions']}</label>
                    <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group" style={{ paddingTop: 10 }}>
                        {
                        !(currentAlert.code == "OffHour") &&
                        <Grid item sm={4}>
                            <Pill
                                textField={'name'}
                                item={{ id: "EveryEvent", name: messages["alertsNewAlert_applyEveryEvent"] }}
                                outlined={schedule?.occurrences != "EveryEvent"}
                                onClick={(entity) => {
                                    onChange({ ...value, schedule: { ...schedule, occurrences: "EveryEvent", afterConsecutiveEvents: 0 } })
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        }
                        {
                            (currentAlert.code == "Speed" || currentAlert.code == "ConsistentSpeed") &&
                            <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "AfterEvent", name: messages["alertsNewAlert_alertAfter"] }}
                                    outlined={schedule?.occurrences != "AfterEvent"}
                                    onClick={(entity) => {
                                        onChange({ ...value, schedule: { ...schedule, occurrences: "AfterEvent" } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                        }
                        {
                            currentAlert.code == "OffHour" 
                            &&
                            <label className='input-information-label'>
                                {messages['alertsNewAlert_hourlySummary_message']}
                            </label>
                        }   
                        {/* <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "HourlySummary", name: `${messages["alertsNewAlert_hourlySummary"]}` }}
                                    outlined={schedule?.occurrences != "HourlySummary"}
                                    onClick={(entity) => {
                                        onChange({ ...value, schedule: { ...schedule, occurrences: "HourlySummary", afterConsecutiveEvents: 0 } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                        </Grid> */}

                        {currentAlert.code == "Inspections" && (
                            <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "FirstOfDay", name: messages["alertsNewAlert_FirstOfDay"] }}
                                    outlined={schedule?.occurrences != "FirstOfDay"}
                                    onClick={(entity) => {
                                        onChange({ ...value, schedule: { ...schedule, occurrences: "FirstOfDay", afterConsecutiveEvents: 0 } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                {
                    schedule?.occurrences === 'AfterEvent' &&
                    <Grid item>
                        <div style={{ width: '100%', marginTop: 10 }}>
                            <label className="input-normal-label">{messages['alertsNewAlert_alertAfterConsecutive']}</label>
                            <Slider
                                min={2}
                                max={100}
                                value={schedule?.afterConsecutiveEvents || 2}
                                onChange={(event) => onChange({ ...value, schedule: { ...schedule, afterConsecutiveEvents: event } })}
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                            />
                        </div>
                    </Grid>

                }

                <Grid item style={{ paddingTop: "20px" }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_totalDailyLimit']}</label>
                    <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group" style={{ paddingTop: 10 }}>
                        <Grid item sm={6}>
                            <Pill
                                textField={'name'}
                                item={{ id: "NO", name: messages["no"] }}
                                outlined={schedule?.occurrencesLimitPerDay > 0}
                                onClick={(entity) => {
                                    onChange({ ...value, schedule: { ...schedule, occurrencesLimitPerDay: 0 } })
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <Pill
                                textField={'name'}
                                item={{ id: "YES", name: messages["yes"] }}
                                outlined={!schedule?.occurrencesLimitPerDay || schedule?.occurrencesLimitPerDay == 0}
                                onClick={(entity) => {
                                    onChange({ ...value, schedule: { ...schedule, occurrencesLimitPerDay: 1 } })
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {
                    schedule?.occurrencesLimitPerDay > 0 &&
                    <Grid item>
                        <div style={{ width: '100%', marginTop: 10 }}>
                            <label className="input-normal-label">{messages['alertsNewAlert_maxAlertPerDay']}</label>
                            <Slider
                                min={1}
                                max={50}
                                value={schedule?.occurrencesLimitPerDay > 50 ? 50: schedule?.occurrencesLimitPerDay}
                                onChange={(event) => onChange({ ...value, schedule: { ...schedule, occurrencesLimitPerDay: event } })}
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                            />
                        </div>
                    </Grid>

                }

                {currentAlert.code == "Inspections" && (
                    <Grid item style={{ paddingTop: 30 }}>
                        <Alert severity='info' className='custom-info-alert'>{messages['alertsNewAlert_InspectionAlertsEvaluateOnlyTripsAndInspectionsThatOccurWithinActiveHours']}</Alert>
                        <Divider style={{ paddingTop: 30 }} />
                    </Grid>
                )}
            </Grid>
        </Form >
    )
}
export default Step2;
